<div id="ic-user-tb-container">

  <div id="ic-rain-shutdown" class="ic-tb-btn" (click)="onShutdownClick()">
    <img ngSrc="assets/img/tb_rain_shutdown.png" width="40" height="40" loading="eager" alt="" class="prevent-select">
    <span id="shutdown-text" class="prevent-select">{{ 'LABEL.RAIN_SHUTDOWN' | translate | uppercase }}</span>
  </div>

  <div id="ic-user-btn-array">
    <div id="btn-activity"
      class="ic-tb-btn small"
      #activityTrigger
      [pTooltip]="'TOOLTIPS.ACTIVITY' | translate"
      tooltipPosition="bottom"
      appendTo="body"
      (click)="toggleActivityMonitor()"
      >
      <img ngSrc="assets/img/tb_alarms.png" width="40" height="40" loading="eager" alt="" class="prevent-select">
      <!-- New activity since the panel was last opened (Figma 12444:58459, AB#20613) -->
      @if (hasNewActivity()) {
        <span class="ic-tb-new-activity-dot" aria-hidden="true"></span>
      }
    </div>
    <!-- Opens and closes the feedback drawer, as the clock does the Activity panel. Help lives in the sidebar. Hidden
         with the feedback flow, so a build without one has no button that does nothing. -->
    @if (feedbackEnabled) {
      <div id="btn-feedback"
        class="ic-tb-btn small"
        role="button"
        tabindex="0"
        aria-controls="ic-feedback-panel"
        [attr.aria-label]="'MENUS.FEEDBACK' | translate"
        [attr.aria-expanded]="feedbackOpen()"
        [class.ic-tb-btn--pressed]="feedbackOpen()"
        [pTooltip]="'MENUS.FEEDBACK' | translate"
        tooltipPosition="bottom"
        appendTo="body"
        (click)="onFeedbackClick()"
        (keydown.enter)="onFeedbackClick()"
        >
        <ic-menu-icons class="ic-tb-feedback-icon prevent-select" iconName="comment-feedback" [svgResizable]="true"></ic-menu-icons>
      </div>
    }
    <div id="ic-user-menu-wrap" class="nt-position-relative">
      <div class="ic-tb-btn small"
        #userMenuTrigger
        (click)="toggleUserMenu($event)"
        >
        <img ngSrc="assets/img/tb_user.png" width="40" height="40" loading="eager" alt="" class="prevent-select">
      </div>

      @if (showUserMenu()) {
        <div class="ic-header-user-menu" #userMenuPanel>
          <div class="ic-header-user-menu-item" role="button" tabindex="0" (click)="onProfileClicked()" (keydown.enter)="onProfileClicked()">
            <ic-menu-icons iconName="person"></ic-menu-icons>
            <span>{{ 'MENUS.PROFILE' | translate }}</span>
          </div>
          <div class="ic-header-user-menu-item" role="button" tabindex="0" (click)="onLogoutClick()" (keydown.enter)="onLogoutClick()">
            <ic-menu-icons iconName="logout"></ic-menu-icons>
            <span>{{ 'MENUS.LOGOUT' | translate }}</span>
          </div>
        </div>
      }
    </div>
  </div>

</div>

<p-drawer [(visible)]="showActivityPanel"
  position="right"
  styleClass="toro-notification-sidebar"
  [modal]="false"
  [showCloseIcon]="false"
  >
  @if (showActivityPanel()) {
    <ic-activity-monitor
      (closePanel)="toggleActivityMonitor()"
    ></ic-activity-monitor>
  }
</p-drawer>
